import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { DriverCredentialService } from '../credential-service/driver-credential.service';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';

@Component({
  selector: 'app-add-credentialed-driver',
  templateUrl: './add-credentialed-driver.component.html',
  styleUrls: ['./add-credentialed-driver.component.css']
})
export class AddCredentialedDriverComponent implements OnInit, OnDestroy {
  user: any;
  driverId: any
  driverForm: FormGroup;
  submitted = false;
  passwordToggleFlag = true;

  constructor(
    private driverService: DriverCredentialService,
    private sharedDataService: SharedDataService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.params
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((params) => {
        this.driverId = params["id"];
        if (this.driverId) {
          this.getDriverById();
        }
      });

    this.driverForm = this.fb.group({
      name: ['', Validators.required],
      driverID: ['', Validators.required],
      username: ['', Validators.required],
      password: ["", Validators.required]
    });

    this.getUser()
  }

  getUser() {
    this.sharedDataService
      .getUser()
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
        }
      });
  }

  getDriverById() {
    this.driverService.getDriverById(this.driverId)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.driverForm.patchValue(data);
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  save() {
    this.submitted = true;
    if (this.driverForm.invalid) return;

    this.driverService.saveDriver(this.driverForm.value, this.driverId)
       .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.router.navigateByUrl("credentialing/credential-drivers");
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  togglePasswordType() {
    this.passwordToggleFlag = !this.passwordToggleFlag;
  }

  get form() {
    return this.driverForm.controls;
  }

  ngOnDestroy() {
  }

}
